module.exports = __webpack_public_path__ + "img/presentaciones.e34ecf40.svg";